import allowed from '@/core/constants/allowed-roles.constant'

function redirectLegacyRoute() {
  return { name: 'NotFound' }
}

const routes = [
  {
    name: 'BPO',
    path: '/safety-management',
    meta: {
      allowedRoles: [...allowed.bpo.roles],
      requiresAuth: true,
      layout: 'home',
      module: 'bpo',
    },
    children: [
      {
        name: 'BPO Home',
        path: 'bpo',
        component: () => import('@/modules/bpo/containers/bpo.container.vue'),
        meta: {
          allowedRoles: [...allowed.bpo.roles],
          breadcrumb: {
            label: 'bpo.title',
            route: 'BPO Home',
          },
        },
      },
      {
        name: 'BPO Training Management',
        path: 'bpo/training-management',
        meta: {
          allowedRoles: [...allowed.bpo.roles],
        },
        component: () =>
          import('@/modules/bpo/containers/training-management.container.vue'),
      },
      {
        name: 'BPO New Training',
        path: 'bpo/training-management/training',
        component: () =>
          import('@/modules/bpo/containers/new-training.container.vue'),
      },
      {
        name: 'BPO Training',
        path: 'bpo/training-management/training/:trainingId',
        component: () =>
          import('@/modules/bpo/containers/new-training.container.vue'),
        props: true,
      },
      {
        name: 'STD Management',
        path: 'bpo/std-management',
        meta: {
          allowedRoles: [...allowed.bpo.roles],
        },
        component: () =>
          import(
            '@/modules/bpo/containers/std-management/std-management.container.vue'
          ),
      },
      {
        name: 'STD Indicator',
        path: 'bpo/std-indicator',
        component: () =>
          import(
            '@/modules/bpo/containers/std-indicator/std-indicator.container.vue'
          ),
      },
      {
        name: 'Reportability Indicator',
        path: 'bpo/reportability-indicator',
        component: () =>
          import(
            '@/modules/bpo/containers/reportability-indicator/reportability-indicator.container.vue'
          ),
      },
      {
        name: 'Training Plan',
        path: 'bpo/training-plan',
        component: () =>
          import(
            '@/modules/bpo/containers/training-plan/training-plan.container.vue'
          ),
      },
      {
        name: 'Yard Security',
        path: 'bpo/yard-security',
        component: () =>
          import(
            '@/modules/bpo/containers/yard-security/yard-security.container.vue'
          ),
        meta: {
          allowedRoles: [...allowed.bpo.roles],
          breadcrumb: {
            label: 'yard-security.title',
            parent: 'BPO Home',
          },
        },
      },
      {
        name: 'Form Management',
        path: 'bpo/form-management',
        beforeEnter: redirectLegacyRoute,
        meta: {
          allowedRoles: [...allowed.bpo.roles],
        },
        component: () =>
          import(
            '@/modules/bpo/containers/form-management/form-management.container.vue'
          ),
      },
      {
        name: 'BPO New Audits And Inspections',
        path: 'bpo/new-audits-inspections',
        meta: {
          allowedRoles: [...allowed.bpo.roles],
          breadcrumb: {
            label: 'bpo.new-audits-inspections.title',
            parent: 'BPO Home',
          },
        },
        component: () =>
          import(
            '@/modules/bpo/containers/new-audits-inspections/new-audits-inspections-home.container.vue'
          ),
      },
      {
        name: 'BPO New Audits And Inspections Answer',
        path: 'bpo/new-audits-inspections/instance/:formInstanceId',
        meta: {
          allowedRoles: [...allowed.bpo.roles],
          breadcrumb: {
            label: 'bpo.new-audits-inspections.answer.title',
            parent: 'BPO New Audits And Inspections',
          },
        },
        component: () =>
          import(
            '@/modules/bpo/containers/new-audits-inspections-answer/new-audits-inspections-answer.container.vue'
          ),
      },
      {
        name: 'BPO New Form Management',
        path: 'bpo/new-form-management',
        meta: {
          allowedRoles: [...allowed.bpo.roles],
          breadcrumb: {
            label: 'bpo.new-form-management.title',
            parent: 'BPO Home',
          },
        },
        component: () =>
          import(
            '@/modules/bpo/containers/new-form-management/new-form-management-home.container.vue'
          ),
      },
      {
        name: 'BPO New Form Management Edit',
        path: 'bpo/new-form-management/form/:id',
        meta: {
          allowedRoles: [...allowed.bpo.roles],
          breadcrumb: {
            label: 'bpo.new-form-management.form.title',
            parent: 'BPO New Form Management',
          },
        },
        component: () =>
          import(
            '@/modules/bpo/containers/new-form-management-edit/new-form-management-edit.container.vue'
          ),
      },
      {
        name: 'Form Management Edit',
        path: 'bpo/form-management/:id',
        beforeEnter: redirectLegacyRoute,
        component: () =>
          import(
            '@/modules/bpo/containers/form-management-edit/form-management-edit.container.vue'
          ),
      },
      {
        name: 'Audits and Inspections',
        path: 'bpo/audits',
        beforeEnter: redirectLegacyRoute,
        component: () =>
          import(
            '@/modules/bpo/containers/audits-inspections-indicator/audits-inspections-indicator.container.vue'
          ),
      },
      {
        path: 'bpo/form-audits-inspections/:id',
        name: 'FormAuditsInspections',
        beforeEnter: redirectLegacyRoute,
        component: () =>
          import(
            '../containers/form-audits-inspections/form-audits-inspections.container.vue'
          ),
        meta: {
          requiresAuth: true,
          roles: [allowed.BPO_USER, allowed.BPO_ADMIN],
        },
      },
      {
        path: 'bpo/inspection/:id',
        name: 'InspectionDetails',
        beforeEnter: redirectLegacyRoute,
        component: () =>
          import(
            '../containers/inspection-details/inspection-details.container.vue'
          ),
        meta: {
          requiresAuth: true,
          roles: [allowed.ACT_USER, allowed.ACT_ADMIN],
        },
      },
      {
        path: 'bpo/inspections',
        name: 'InspectionsList',
        beforeEnter: redirectLegacyRoute,
        component: () =>
          import('../containers/form-audits-inspections/list.container.vue'),
        meta: {
          requiresAuth: true,
          roles: [allowed.ACT_USER, allowed.ACT_ADMIN],
        },
      },
    ],
  },
]

export default routes
